<template>
  <section class="card-information" v-if="card.cardInformation">
    <h4 class="secondary-font">Card Information</h4>

    <p v-html="card.cardInformation" />
  </section>
</template>

<script>
export default {
  props: {
    card: Object,
  },
};
</script>

<style lang="scss" scoped>
@import '../scss/variables.scss';

.card-information {
  padding-top: $gp;
  border-top: solid 1px var(--theme-border);
  margin-bottom: $gp * 1.5;
}
</style>
